import { Component, OnInit } from '@angular/core';
import {WifiMenuDataService} from "./wifiMenuDataService";
import {WifiMenuData} from "./wifimenudata";

@Component({
  selector: 'app-wifi-menu-data',
  templateUrl: './wifi-menu-data.component.html',
  styleUrls: ['./wifi-menu-data.component.css']
})
export class WifiMenuDataComponent implements OnInit {
  wifiMenuData: WifiMenuData;

  constructor(private wifiMenuDataService: WifiMenuDataService ) {
    this.wifiMenuData = new WifiMenuData();
  }

  ngOnInit(): void {
    this.wifiMenuDataService.GetData().subscribe(
      {
        next: menudata => {
          this.wifiMenuData = menudata;
        }
      });
  }
}
